import React from 'react';
import {
  formatDate,
} from 'utils/date';
import {
  isEmptyString,
} from 'utils/misc';
import {
  formatPhone,
  getAddressString,
  getFullName,
} from 'utils/string';
import {
  InsuranceDataForm,
} from '@/components/InsuranceForm';
import clsx from 'clsx';

type Parts = 'root' | 'title' | 'value';

export default function DemographicsHeader({
  demographics,
  insuranceOwnerPhoneNumber: phone,
  insuranceOwnerAddress: address,
  hasAddress = false,
  showHeader = true,
  className,
  classes,
}: Partial<Pick<InsuranceDataForm,
  | 'demographics'
  | 'insuranceOwnerPhoneNumber'
  | 'insuranceOwnerAddress'
>> & { hasAddress?: boolean;
  phone?: string;
  showHeader?: boolean;
  className?: string;
  classes?: Partial<Record<Parts, string>>;
}) {
  return (
    <div className={clsx('flex flex-col w-full font-normal text-black', className)}>
      {showHeader && (
        <h3 className={clsx('font-semibold text-gray-700 mb-1', classes?.title)}>
          Subscriber
        </h3>
      )}
      <p>
        <strong className="font-semibold">
          {getFullName(demographics ?? {})}
          {` (${demographics?.genderDescription})`}
        </strong>
        {' born on '}
        <strong className="font-semibold">
          {formatDate(demographics?.dateOfBirth ?? '')}
        </strong>
      </p>
      {hasAddress && (
        <p className="whitespace-pre-wrap break-words overflow-auto">{getAddressString(address, true)}</p>
      )}
      {!isEmptyString(phone) && (
        <p className="whitespace-pre-wrap break-words">{formatPhone(phone ?? '')}</p>
      )}
    </div>
  );
}
